// import react from 'react';
// import Logo from "../Assests/images/Logo 4.png";


// const Video = () => {
//     return (
//         <div className="video-navbar-container mb-10">
//             <img src={Logo} alt="Logo" className='video-navbar-logo'/>
//             <div className='video-Content'>
//                 <div className='video-heading'>
//                     Wellness CLINICAL Study 
//                 </div>
//                 {/* <div className='video-subheading'>
//                     Instruction For CGM 
//                 </div>
//                 <div className='video-Content'>
//                     <video width="640" height="360" controls>
//                         <source 
//                         src="https://aiwellassets.s3.ap-south-1.amazonaws.com/Sinocare+iCan+i3+CGM+-Instruction+Video+1.mp4" 
//                         type="video/mp4" 
//                         />
//                         Your browser does not support the video tag.
//                     </video>
//                 </div> */}
//                 <div className='video-subheading'>
//                     Instruction For Stool Sample Collection
//                 </div>

//                 <div className='video-Content'>
//                     <video width="450" height="250" controls>
//                         <source 
//                         src="https://aiwellassets.s3.ap-south-1.amazonaws.com/Stool+collection+video+B2_12062025.MP4" 
//                         type="video/mp4" 
//                         />
//                         Your browser does not support the video tag.
//                     </video>
//                 </div>

//             </div>
//         </div>
//     )
// }
// export default Video;


import React from 'react';
import Logo from "../Assests/images/Logo 4.png";

const Video1 = () => {
    return (
        <div className="video-navbar-container mb-10">
            <img src={Logo} alt="Logo" className='video-navbar-logo' />
            <div className='video-Content'>
                <div style={{ textAlign: 'center' }}>
                    <div className="video-heading">Gastric Wellness CLINICAL Study</div>
                </div>

                {/* <div className='video-subheading'>
                    Instruction For CGM
                </div>
                <div className='video-Content'>
                    <video width="640" height="360" controls>
                        <source
                            src="https://aiwellassets.s3.ap-south-1.amazonaws.com/Sinocare+iCan+i3+CGM+-Instruction+Video+1.mp4"
                            type="video/mp4"
                        />
                        Your browser does not support the video tag.
                    </video>
                </div> */}
                <div className='video-subheading'>
                    Instruction For Stool Sample Collection
                </div>
                <div className='video-Content'>
                    <video width="450" height="250" controls>
                        <source
                            src="https://aiwellassets.s3.ap-south-1.amazonaws.com/Stool+collection+video+B2_12062025.MP4"
                            type="video/mp4"
                        />
                        Your browser does not support the video tag.
                    </video>
                </div>


                {/* Blood and Urine Sample Collection Instructions - Unchanged */}
                <div className='blood-urine-instructions-container' style={{ marginTop: '30px', padding: '0 20px' }}>
                    <div className='video-subheading' style={{ marginBottom: '15px' }}>
                        Instructions for Clinical Study Participants: (Blood and Urine Sample Collection)
                    </div>
                    <div className='blood-urine-content' style={{ textAlign: 'left' }}>
                        <h4>A. Before Breakfast Blood Sample Collection :</h4>
                        <ul>
                            <li>Participants are advised not to eat or drink anything except plain water for 8–12 hours before the test, preferably finishing dinner before 10PM is recommended.</li>
                            <li>Avoid caffeine or exercise during fasting.</li>
                            <li>The sample collection will done between 6 AM -7 AM at your home on a scheduled date as per your convenience by the lab.</li>
                            <li>Drink a small amount of plain water in the morning if needed (avoid dehydration).</li>
                        </ul>

                        <h4>B. Urine Sample Collection : </h4>
                        <ul>
                            <li>Participants will be asked to provide a urine sample along with their fasting blood sample collection.</li>
                            <li>It is recommended to retain the first morning urine, as it is often preferred for better diagnostic accuracy.</li>
                            <li>Drinking a moderate amount of water (1–2 glasses) about 1 hour before your visit is advised to ensure you can comfortably provide a sample.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Video1;